/* eslint-disable react-hooks/exhaustive-deps */
import { useQuery } from '@tanstack/react-query';
import { getPlan } from 'api';
import { useAccount } from 'hooks';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { ConfigPlan } from 'types';
import { useDebounce } from 'use-debounce';
import {
  errorPlanInfoAtom,
  loadingPlanInfoAtom,
  planInfoAtom,
} from './plan.state';

export const useFetchPlan = () => {
  const { accountInfo, accountInfoStatus } = useAccount();
  const setPlanInfo = useSetAtom(planInfoAtom);
  const setLoadingPlanInfo = useSetAtom(loadingPlanInfoAtom);
  const setErrorPlanInfo = useSetAtom(errorPlanInfoAtom);

  const { status: planInfoStatus, data: planInfo } = useQuery<ConfigPlan>(
    ['planInfo', accountInfo?.descriptionPlan],
    ({ queryKey: [_, planType] }) => getPlan(planType as string),
    {
      enabled: !!accountInfo?.planType,
      refetchOnWindowFocus: false,
    },
  );

  const [debouncedLoadingPlanInfo] = useDebounce(
    planInfoStatus === 'loading' || accountInfoStatus === 'loading',
    500,
  );

  const [debouncedErrorPlanInfo] = useDebounce(
    planInfoStatus === 'error' || accountInfoStatus === 'error',
    500,
  );

  useEffect(() => {
    planInfo?.plan && setPlanInfo(planInfo);
    setLoadingPlanInfo(debouncedLoadingPlanInfo);
    setErrorPlanInfo(debouncedErrorPlanInfo);
  }, [planInfo, debouncedLoadingPlanInfo, debouncedErrorPlanInfo]);

  return {
    planInfo,
    loadingPlanInfo: debouncedLoadingPlanInfo,
    errorPlanInfo: debouncedErrorPlanInfo,
  };
};
